<template>
  <div class="container">
    <h1 class="py-4">パートナー管理</h1>
    <router-link :to="{ name: 'Partners' }">パートナー一覧に戻る</router-link>
    <h3 class="py-4">パートナー詳細</h3>
    <div class="pb-4">
      <div class="form-row">
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder propertyPartner d-flex">
            <p>パートナー名</p>
          </div>
          <div class="greyBorder valuePartner d-flex">
            <p>{{ partnerName }}</p>
          </div>
        </div>
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder propertyPartner d-flex">
            <p>業種</p>
          </div>
          <div class="greyBorderNoTop valuePartner d-flex">
            <p>{{ type.display }}</p>
          </div>
        </div>
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder propertyPartner d-flex">
            <p>URL</p>
          </div>
          <div class="greyBorderNoTop valuePartner d-flex">
            <p>{{ url }}</p>
          </div>
        </div>
        <div class="d-flex datacontainerFullWidthAutoHeight flex-nowrap">
          <div class="grey-background greyBorder propertyPartnerBis d-flex">
            <p>ロゴ画像</p>
          </div>
          <div class="greyBorderNoTop valuePartner d-flex">
            <img
              class="ml20 mt20 mb20 mr20"
              v-if="previewImage"
              :src="previewImage"
            />
          </div>
        </div>
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder propertyPartner d-flex">
            <p>日本語紹介文</p>
          </div>
          <div class="greyBorderNoTop valuePartner d-flex">
            <p>{{ descriptionJP }}</p>
          </div>
        </div>
        <div class="d-flex datacontainerFullWidthAutoHeight flex-nowrap">
          <div
            class="grey-background greyBorderNoTop propertyPartnerBis d-flex"
          >
            <p>英語紹介文</p>
          </div>
          <div class="greyBorderNoTop valuePartner minHeight50 d-flex">
            <p>{{ descriptionEN }}</p>
          </div>
        </div>
      </div>
      <div class="text-right mt20">
        <button class="btn btn-danger mr10" @click="modalDelete">
          削除
        </button>
        <button class="btn btn-success mr10" @click="updatePartner">
          変更
        </button>
      </div>
      <modal
        name="deletePartner"
        :clickToClose="false"
        :adaptive="true"
        width="50%"
        height="50%"
      >
        <div class="text-center-modal">
          <p>パートナーを削除しますか？</p>
          <p>削除するとデータが削除されます。</p>
          <div>
            <button
              class="btn btn-secondary buttonSetWidth mr20"
              @click="closeDeleteModal"
            >
              キャンセル
            </button>
            <button
              class="btn btn-danger buttonSetWidth ml20"
              @click="deletePartner"
            >
              削除
            </button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import master from "@/constants/MasterEnum";

export default {
  name: "PartnerDetails",
  mixins: [master],
  data() {
    return {
      documentId: "",
      db: firebase.firestore(),
      previewImage: null,
      partnerName: "",
      descriptionJP: "",
      descriptionEN: "",
      type: "",
      imageName: "",
      url: "",
      pid: "",
      file: null,
    };
  },
  created: function() {
    this.loadPartnerData();
  },
  methods: {
    updatePartner() {
      this.$router.push({
        name: "EditPartner",
        query: { documentId: this.documentId },
      });
    },
    modalDelete() {
      this.$modal.show("deletePartner");
    },
    closeDeleteModal() {
      this.$modal.hide("deletePartner");
    },
    async deletePartner() {
      await this.db
        .collection("partners")
        .doc(this.documentId)
        .delete();
      this.$router.push({ name: "Partners" });
    },
    imageSelected(e) {
      const file = e.target.files[0];
      if (file !== undefined) {
        let fileNameSplit = file.name.split(".");
        let fileFormat = fileNameSplit[fileNameSplit.length - 1];
        if (
          fileFormat == "jpg" ||
          fileFormat == "jpeg" ||
          fileFormat == "png"
        ) {
          this.imageName = file.name;
          this.file = file;
          this.previewImage = URL.createObjectURL(file);
        } else {
          this.file = null;
          this.previewImage = null;
        }
      } else {
        this.previewImage = null;
        this.file = null;
      }
    },
    async loadPartnerData() {
      this.loading = true;
      let snapshot = await this.db
        .collection("partners")
        .where("pid", "==", this.$route.query.pid)
        .limit(1)
        .get();
      if (!snapshot.empty) {
        let partnerDocument = snapshot.docs[0];
        this.documentId = partnerDocument.id;
        let partnerData = partnerDocument.data();
        this.pid = partnerData.pid;
        this.url = partnerData.url;
        this.type = this.industries.find(
          (element) => element.value == partnerData.type
        );
        this.partnerName = partnerData.partnerName;
        this.previewImage = partnerData.imageUrl;
        this.descriptionJP = partnerData.descriptionJP;
        this.descriptionEN = partnerData.descriptionEN;
      }
      this.loading = false;
    },
  },
};
</script>
